import { DamageDetectionDto, DamageDetectionReferenceDto } from "@/core/api/generated/v1";

/** Any entity DTO type according to @type EntityFormType */
export type DamageDetectionDtoAny = DamageDetectionDto | DamageDetectionReferenceDto;

/** All entity DTO types according to @type EntityFormType */
export type DamageDetectionDtoAll = DamageDetectionDto & DamageDetectionReferenceDto;

export class DamageDetectionMapper {}
